export const setURLs = (urls) => (dispatch) => {
    dispatch({
        type: 'SET_URLS',
        payload: urls.serviceURLs
    })
}

export const setPdfDocument = (value) => (dispatch) => {
    dispatch({
        type: 'SET_PDF_DOCUMENT',
        payload: value
    })
}


export const setImageForSign = (image) => (dispatch) => {
    dispatch({
        type: 'SET_IMAGE_FOR_SIGN',
        payload: image
    })
}

export const setCommonName = (value) => (dispatch) => {
    dispatch({
        type: 'SET_COMMON_NAME',
        payload: value
    })
}

export const setMacPassword = (value) => (dispatch) => {
    dispatch({
        type: 'SET_MAC_PASSWORD',
        payload: value
    })
}

export const setGlobalProcessing = (value) => (dispatch) => {
    dispatch({
        type: 'SET_GLOBAL_PROCESSING',
        payload: value
    })
}

export const setSignaturePageNumder = (value) => (dispatch) => {
    dispatch({
        type: 'SET_SIGNATURE_PAGE_NUMBER',
        payload: value
    })
}

export const setSignaturePositionX = (value) => (dispatch) => {
    dispatch({
        type: 'SET_SIGNATURE_POSITION_X',
        payload: value
    })
}

export const setSignaturePositionY = (value) => (dispatch) => {
    dispatch({
        type: 'SET_SIGNATURE_POSITION_Y',
        payload: value
    })
}

export const setSignedDataForInputFile = (value) => (dispatch) => {
    dispatch({
        type: 'SET_SIGNED_DATA_FOR_INPUT_FILE',
        payload: value
    })
}

export const setConvertedImage = (base64) => (dispatch) => {
    dispatch({
        type: 'SET_CONVERTED_IMAGE',
        payload: base64
    })
}

export const setVerifyInputData = (data) => (dispatch) => {
    dispatch({
        type: 'SET_VERIFY_INPUT_DATA',
        payload: data
    })
}

export const setMacPasses = (data) => (dispatch) => {
    dispatch({
        type: 'SET_MAC_PASSES',
        payload: data
    })
}

export const setVerifyResultsArray = (result) => (dispatch) => {
    dispatch({
        type: 'SET_VERIFY_RESULTS_ARRAY',
        payload: result
    })
}

export const setIndexiesArray = (result) => (dispatch) => {
    dispatch({
        type: 'SET_INDEXIES_ARRAY',
        payload: result
    })
}

export const setWithAuSigVerificationResultArray = (result) => (dispatch) => {
    dispatch({
        type: 'SET_WITH_AUSIG_VERIFICATION_RESULT_ARRAY',
        payload: result
    })
}

export const setShowedObjectsArray = (data) => (dispatch) => {
    dispatch({
        type: 'SET_SHOWED_OBJECTS_ARRAY',
        payload: data
    })
}

export const setShowErrorPopup = (value) => (dispatch) => {
    dispatch({
        type: 'SET_SHOW_ERROR_POPUP',
        payload: value
    })
}

export const setErrorData = (value) => (dispatch) => {
    dispatch({
        type: 'SET_ERROR_DATA',
        payload: value
    })
}

export const setShowPdfPreviewer = (value) => (dispatch) => {
    dispatch({
        type: 'SET_SHOW_PDF_PREVIEWER',
        payload: value
    })
}

export const setSignatureSize = (value) => (dispatch) => {
    dispatch({
        type: 'SET_SIGNATURE_SIZE',
        payload: value
    })
}

export const setShowedOnce = (value) => (dispatch) => {
    dispatch({
        type: 'SET_SHOWED_ONCE',
        payload: value
    })
}

export const setImageParamsSetted = (value) => (dispatch) => {
    dispatch({
        type: 'SET_IMAGE_PARAMS_SETTED',
        payload: value
    })
}